import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { NaviGate } from "../../../Utility/function";

const Reports = () => {
    const navigate = useNavigate();
    const [search, setSearch] = useState("");

    const menuItems = [
        {
            name: "Supplier Transaction",
            route: "/supplier-transaction",
            icon: "bi bi-bar-chart",
            url: "assets/images/menu/document.png",
        },
        {
            name: "Customer Transaction",
            route: "/customr-transaction",
            icon: "bi bi-bar-chart",
            url: "assets/images/menu/document.png",
        },
        // {
        //     name: "Service Transaction",
        //     route: "/service-transaction",
        //     icon: "bi bi-bar-chart",
        //     url: "assets/images/menu/document.png",
        // },
        // {
        //     name: "Sales Report",
        //     route: "/daily_sales_report",
        //     icon: "bi bi-bar-chart",
        //     url: "assets/images/menu/document.png",
        // },
        {
            name: "Daily Transaction",
            route: "/all-transaction",
            icon: "bi bi-bar-chart",
            url: "assets/images/menu/document.png",
        },
        {
            name: "Sales Report",
            route: "/sales_report",
            icon: "bi bi-bar-chart",
            url: "assets/images/menu/sales-report.png",
        },
        {
            name: "Purchase Report",
            route: "/purchase-report",
            icon: "bi bi-receipt",
            url: "assets/images/menu/purchase report.png",
        },
        {
            name: "Profit Loss Batch Report",
            route: "/pobatch-report",
            icon: "bi bi-receipt",
            url: "assets/images/menu/purchase report.png",
        },
        {
            name: "Raw Material Report",
            route: "/raw-material-report",
            icon: "bi bi-bar-chart",
            url: "assets/images/menu/document.png",
        },
        {
            name: "Finished Product Report",
            route: "/finished-product-report",
            icon: "bi bi-bar-chart",
            url: "assets/images/menu/sales-report.png",
        },
        // {
        //     name: "Service Report",
        //     route: "/service-report",
        //     icon: "bi bi-receipt",
        //     url: "assets/images/menu/srvice report (3).png",
        // },
        // {
        //     name: "Stock Report",
        //     route: "/stock-report",
        //     icon: "bi bi-receipt",
        //     url: "assets/images/menu/srvice report (3).png",
        // },
        // {
        //     name: "Profit/Loss Report",
        //     route: "/profitloss-report",
        //     icon: "bi bi-receipt",
        //     url: "assets/images/menu/document.png",
        // },
        // {
        //     name: "Profit/Loss Report",
        //     route: "/profitloss-report",
        //     icon: "bi bi-receipt",
        //     url: "assets/images/menu/profitloss.png",
        // },
        // {
        //     name: "Total Daily Report",
        //     route: "/total_daily_report",
        //     icon: "bi bi-receipt",
        //     url: "assets/images/menu/document.png",
        // },
    ];

    const handleCardClick = (route) => {
        navigate(route);
    };

    return (
        <div className="my-4 mx-3 pb-5">
            <NaviGate />
            <h6 className="mt-4 pt-4 mx-4 text-uppercase">Reports</h6>
            <div
                className="product-grid row d-flex justify-content-center align-items-center"
                style={{ padding: "10px 25px", minHeight: "50vh" }}
            >
                {menuItems
                    .filter((item) =>
                        item.name.toLowerCase().includes(search.toLowerCase())
                    )
                    .map((item, index) => (
                        <div className="col-12 col-md-4 col-lg-2 mb-2 mt-2" key={index}>
                            <div
                                className="card h-100 text-center"
                                onClick={() => handleCardClick(item.route)}
                                style={{ cursor: "pointer" }}
                            >
                                <div className="card-body">
                                    <img
                                        src={item?.url}
                                        width={"50px"}
                                        style={{ marginTop: "8px" }}
                                        alt={item.name}
                                    />
                                    <h5 className="card-title mt-3 text-small">{item.name}</h5>
                                </div>
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default Reports;
